import { Route, Routes } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';

import FicheMenage from './menage/FicheMenage';
import ListeDuJour from './menage/ListeDuJour';

/**
 * L'écran « Mes chambres » du registre, et son routage interne — lot 3 Odomo.
 *
 * Même forme que `Messagerie` : le registre monte ce composant derrière
 * `/housekeeping/*`, et les sous-chemins lui appartiennent. `/housekeeping` est la
 * liste du jour — c'est là que mène le push d'affectation (`mobile_path`) ;
 * `/housekeeping/:serviceId` est la fiche ménage d'une chambre.
 *
 * La clé remonte tout à neuf quand l'établissement change (#25) : ni la liste ni
 * une fiche ouverte ne survivent à une bascule d'hôtel.
 */
export default function MesChambres() {
    const { currentFacility } = useStateContext();
    const cleEtablissement = String(currentFacility?.id ?? 'aucun');

    return (
        <Routes>
            <Route index element={<ListeDuJour key={cleEtablissement} />} />
            <Route path=":serviceId" element={<FicheMenage key={cleEtablissement} />} />
        </Routes>
    );
}
